import styled, { css } from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

// Re-export shared styles from CardisPropertyCharacteristics
export {
  PageContainer,
  ContentArea,
  Title,
  SectionHeader,
  DetailsSubheader,
  DescriptionText,
  FooterWrapper,
  FooterPattern,
  Footer,
  PageNumber,
} from '../CardisPropertyCharacteristics/CardisPropertyCharacteristics.styles'

const printStyles = css`
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

// Map container - blue background with padding like MetricsCard
export const MapContainer = styled.div`
  background-color: ${cardisTheme.colors.primary};
  margin-left: -51px;
  margin-right: -51px;
  margin-top: 20px;
  padding: 20px;
  overflow: hidden;
  position: relative;

  @media print {
    background-color: ${cardisTheme.colors.primary} !important;
    margin-left: -51px !important;
    margin-right: -51px !important;
    margin-top: 20px !important;
    padding: 38px 48px !important;
    overflow: hidden !important;
    ${printStyles}

    /* Hide all map controls and buttons on print */
    button,
    .mapboxgl-ctrl,
    .mapboxgl-ctrl-group,
    .maplibregl-ctrl,
    .maplibregl-ctrl-group,
    [class*='MapControls'],
    [class*='map-controls'],
    [class*='Controls'] {
      display: none !important;
      visibility: hidden !important;
    }
  }
`

// Inner map wrapper to set the map height
export const MapInner = styled.div`
  height: 224px;
  width: 100%;
  overflow: hidden;
`

// Section wrapper for SITUATION and RÉNOVATION sections
export const SectionWrapper = styled.div`
  margin-top: 13px;

  @media print {
    margin-top: 13px !important;
  }
`
